export default __webpack_public_path__ + "static/media/message-bg.8c374a9f.svg";